<div class="container py-3 py-md-4 pb-6 pb-md-9" *ngIf="vehicular">

  <div>
    <p class="small text-primary">SEGURO VEHICULAR</p>
    <p class="lead">Gracias tu consulta ha sido enviada, en breve nos pondremos en contacto.</p>
  </div>

</div>